{
  "sdk-download-android": "Android үшін жүктеп алу",
  "sdk-connect": "Қосылу",
  "sdk-download-ios": "iOS үшін жүктеп алу",
  "sdk-install": "Орнату",
  "sdk-modal-instruct-1": "1. Binance қолданбасын ашыңыз",
  "sdk-modal-instruct-2": "2. Басты экрандағы {{icon}} белгішесін түртіңіз",
  "sdk-modal-title": "Binance платформасымен байланыстыру",
  "sdk-no-app": "Сізде әлі Binance қолданбасы жоқ па?"
}